// @flow
import styled from 'styled-components';
import * as React from 'react';
import { below } from '../../assets/css/media';
import colors from '../../assets/css/colors';
import {
	RotatedLabel,
	PlayerTableCell,
	PlayerInfo,
	FilledIcon
} from '../';
import Revert from '../Icons/Revert';
import { TradeCell } from './TradeCell';

const OutCellStyled = styled(TradeCell)`
	text-align: right;
	flex-direction: row-reverse;
	${PlayerTableCell} {
		justify-content: flex-end;
	}
	.player-info {
		flex-direction: row-reverse;
		text-align: right;
		.player-avatar {
			margin-left: 5px;
		}
		div {
			align-items: flex-end;
		}
	}
	.filled-icon {
		margin-left: 4em;
		margin-right: auto;
		${below.desktop`
			margin-left: 1em;
		`}
	}
`;
type TCell = {
	removePlayer?: Function,
	player: Object
};
export const TradeOutCell = ({ player, removePlayer }: TCell) => {
	return (
		<OutCellStyled>
			<PlayerTableCell width="260px" height="60px" justify="flex-start">
				<PlayerInfo player={player} className="player-info" reverse />
				<RotatedLabel
					background={colors.red}
					text="OUT"
					border_radius="0 2px 2px 0"
					rotate="90" />
			</PlayerTableCell>
			{removePlayer ? (
				<FilledIcon
					background={colors.red}
					className="filled-icon"
					onClick={() => removePlayer({ id: player.id })}
				>
					<Revert color="#fff" />
				</FilledIcon>
			) : null}

		</OutCellStyled>
	);
};

export default TradeOutCell;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeOutCell.js